module.exports = __webpack_public_path__ + "img/comochegar01.f11ec5c2.png";